import type { FinanceContactDto, FinanceContactListResponse } from '@signalvote/shared';
import type { Read } from '@signalvote/data';

const NO_CONTACTS: FinanceContactDto[] = [];

/** Why a contacts read has nothing to show yet, in words, or null when it answered or is still loading. */
export function contactsUnreadyMessage(read: { status: string }): string | null {
  if (read.status === 'failed') return "Couldn't load contacts. Try again shortly.";
  if (read.status === 'offline') return "You're offline, so contacts can't load.";
  return null;
}

/** The rows a contact picker can offer: the page's rows once the read answered, none before. */
export function contactRows(read: Read<FinanceContactListResponse>): FinanceContactDto[] {
  return read.status === 'ready' || read.status === 'placeholder' ? read.data.items : NO_CONTACTS;
}
